import NotEmployedPrimary from './NotEmployedPrimary';
import NotEmployedSecondary from './NotEmployedSecondary';

import { EmploymentClassType } from '../../PrimaryEmployment/types';

export interface PrimaryNotEmployedProps {
  type: Extract<EmploymentClassType, 'primary'>;
}

export interface SecondaryNotEmployedProps {
  type: Extract<EmploymentClassType, 'secondary'>;
  index: number;
  arrayName: string;
}

export type NotEmployedProps =
  | PrimaryNotEmployedProps
  | SecondaryNotEmployedProps;

const NotEmployed: React.FunctionComponent<NotEmployedProps> = function (
  props,
) {
  const { type } = props;
  if (type === 'secondary') {
    const { index, arrayName } = props;
    return <NotEmployedSecondary index={index} arrayName={arrayName} />;
  }
  return <NotEmployedPrimary />;
};

export default NotEmployed;
